import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { phoneNumberMask } from '../../Utils/FormUtils';

import { StyledRadioLabel, StyledLabel, StyledTextInput, StyledMaskedInput, StyledSelect, StyledErrorMessage } from './FormStyles';

export var RadioButton = function RadioButton(_ref) {
  var _ref$form = _ref.form,
      setFieldValue = _ref$form.setFieldValue,
      setFieldTouched = _ref$form.setFieldTouched,
      _ref$field = _ref.field,
      name = _ref$field.name,
      value = _ref$field.value,
      onChange = _ref$field.onChange,
      onBlur = _ref$field.onBlur,
      radioValue = _ref.radioValue,
      label = _ref.label;

  var resetFieldsOnClick = function resetFieldsOnClick() {
    setFieldTouched('phone', false);
    setFieldTouched('email', false);
    setFieldValue('phone', '');
    setFieldValue('email', '');
  };

  return React.createElement(
    StyledRadioLabel,
    null,
    React.createElement('input', {
      name: name,
      type: 'radio',
      value: radioValue,
      checked: radioValue === value,
      onChange: onChange,
      onBlur: onBlur,
      onClick: resetFieldsOnClick
    }),
    React.createElement(
      'span',
      null,
      label
    )
  );
};

RadioButton.propTypes = {
  form: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  radioValue: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export var TextInput = function TextInput(_ref2) {
  var _ref2$form = _ref2.form,
      touched = _ref2$form.touched,
      errors = _ref2$form.errors,
      _ref2$field = _ref2.field,
      name = _ref2$field.name,
      onChange = _ref2$field.onChange,
      onBlur = _ref2$field.onBlur,
      type = _ref2.type,
      label = _ref2.label,
      placeholder = _ref2.placeholder,
      hideLabel = _ref2.hideLabel;

  if (hideLabel) {
    return React.createElement(
      Fragment,
      null,
      type === 'phone' ? React.createElement(StyledMaskedInput, {
        name: name,
        mask: phoneNumberMask,
        placeholder: placeholder,
        type: type,
        onChange: onChange,
        onBlur: onBlur,
        error: touched[name] && errors[name],
        'aria-label': label
      }) : React.createElement(StyledTextInput, {
        name: name,
        type: type,
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onBlur,
        error: touched[name] && errors[name],
        'aria-label': label
      }),
      touched[name] && errors[name] && React.createElement(
        StyledErrorMessage,
        null,
        errors[name]
      )
    );
  } else {
    return React.createElement(
      StyledLabel,
      null,
      label,
      type === 'phone' ? React.createElement(StyledMaskedInput, {
        name: name,
        mask: phoneNumberMask,
        placeholder: placeholder,
        type: type,
        onChange: onChange,
        onBlur: onBlur,
        error: touched[name] && errors[name]
      }) : React.createElement(StyledTextInput, {
        name: name,
        type: type,
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onBlur,
        error: touched[name] && errors[name]
      }),
      touched[name] && errors[name] && React.createElement(
        StyledErrorMessage,
        null,
        errors[name]
      )
    );
  }
};

TextInput.propTypes = {
  form: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool
};

export var SelectInput = function SelectInput(_ref3) {
  var _ref3$form = _ref3.form,
      touched = _ref3$form.touched,
      errors = _ref3$form.errors,
      _ref3$field = _ref3.field,
      name = _ref3$field.name,
      value = _ref3$field.value,
      onChange = _ref3$field.onChange,
      onBlur = _ref3$field.onBlur,
      label = _ref3.label,
      options = _ref3.options;

  return React.createElement(
    StyledLabel,
    null,
    label,
    React.createElement(
      StyledSelect,
      {
        name: name,
        type: 'select',
        onChange: onChange,
        onBlur: onBlur,
        style: { display: 'block', width: '100%' },
        error: touched[name] && errors[name],
        placeholderText: value === '',
        defaultValue: value
      },
      options.map(function (opt) {
        return React.createElement(
          'option',
          { key: opt.value, value: opt.value, disabled: opt.disabled },
          opt.label
        );
      })
    ),
    touched[name] && errors[name] && React.createElement(
      StyledErrorMessage,
      null,
      errors[name]
    )
  );
};

SelectInput.propTypes = {
  form: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
};